import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
    IApiListParams,
    IToolUserDocumentApiListResponse,
    IToolUserDocumentDeleteParams,
    IToolUserDocumentMutationResponse,
    IToolUserDocumentUpdateParams,
} from '@/types';

export const toolUserDocumentList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserDocumentApiListResponse>> => {
    return axios.get('/api/document/list', { ...config, params });
};

export const toolUserDocumentFileDownload = (documentId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<Blob>> => {
    return axios.get(`/api/document/file/${documentId}`, { ...config, responseType: 'blob' });
};

export const toolUserDocumentDelete = (params: IToolUserDocumentDeleteParams, config?: AxiosRequestConfig): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/document/delete', params, config);
};

export const toolUserDocumentUpdate = (
    params: IToolUserDocumentUpdateParams,
    config?: AxiosRequestConfig
): Promise<AxiosResponse<IToolUserDocumentMutationResponse>> => {
    return axios.post('/api/document/update', params, config);
};
